import controller from './home.controller';
import templateBase from './templates/home-base.view.html';
import templateT1 from './templates/home-t1.view.html';
import templateT2 from './templates/home-t2.view.html';
import templateT3 from './templates/home-t3.view.html';
import templateT4 from './templates/home-t4.view.html';
import templateT5 from './templates/home-t5.view.html';
import templateT6 from './templates/home-t6.view.html';
import templateT7 from './templates/home-t7.view.html';
import templateT10 from './templates/home-t10.view.html';
import templateT11 from './templates/home-t11.view.html';
import templateT13 from './templates/home-t13.view.html';
import templateT15 from './templates/home-t15.view.html';
import templateAD from './templates/home-adaptative.html';

let HomeComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  }else{
     if(response.HOME.component == 'template_t1'){ return templateT1 }
     else if(response.HOME.component == 'template_t2'){ return templateT2}
     else if(response.HOME.component == 'template_t3'){ return templateT3}
     else if(response.HOME.component == 'template_t4'){ return templateT4}
     else if(response.HOME.component == 'template_t5'){ return templateT5}
     else if(response.HOME.component == 'template_t6'){ return templateT6}
     else if(response.HOME.component == 'template_t7'){ return templateT7}
     else if(response.HOME.component == 'template_t10'){ return templateT10}
     else if(response.HOME.component == 'template_t11'){ return templateT11}
     else if(response.HOME.component == 'template_t13'){ return templateT13}
     else if(response.HOME.component == 'template_t15'){ return templateT15}
     else{
      return templateBase;
     }
  }
}

export default HomeComponent;


// WEBPACK FOOTER //
// ./www/components/home/home.component.js